import { Repository } from "src/firebase/firestore/repository";
import { Statistics, StatisticsType } from "../types/statistics.entity";
import { doc, updateDoc } from "firebase/firestore";
import { UserLangCode } from "@utils/util.types";
import { db } from "src/firebase";

export class StatisticsRepository extends Repository<Statistics> {
  constructor() {
    super("statistics");
  }

  async findByTypesAndLangCode({
    types,
    langCode,
  }: {
    types: Statistics["type"][];
    langCode?: Statistics["langCode"];
  }): Promise<Statistics[]> {
    const ids = types.map((type) => this.getDocIdFromTypeAndLangCode(type, langCode));
    return super.findByIds(ids);
  }

  async updateByType(type: Statistics["type"], newData: Statistics) {
    const existingDoc = await this.findByTypeAndLangCode(type, newData.langCode);

    if (!existingDoc) {
      await this.setById(this.getDocIdFromTypeAndLangCode(type, newData.langCode), newData);
      return;
    }

    await updateDoc(doc(db, this.collectionName, existingDoc.id!), newData);
  }

  async findByTypeAndLangCode(type: StatisticsType, langCode?: UserLangCode): Promise<Statistics | null> {
    const id = this.getDocIdFromTypeAndLangCode(type, langCode);
    return await this.findById(id);
  }

  private getDocIdFromTypeAndLangCode(type: StatisticsType, langCode?: UserLangCode) {
    return `${type}${langCode ? "_" + langCode : ""}`;
  }
}

export const statisticsRepository = new StatisticsRepository();
